"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyNodeFilter = exports.filterNodeList = exports.getFilterFnsFromFilterGroups = void 0;
const lambda_1 = require("../../lambda");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
const predicateToTestFn = {
    [iotv_v3_types_1.ComparisonType.EQUALS]: (key, value) => (item) => item[key] === value,
    [iotv_v3_types_1.ComparisonType.NOT_EQUALS]: (key, value) => (item) => item[key] !== value,
    [iotv_v3_types_1.ExpressionFunctionType.CONTAINS]: (key, value) => (item) => item[key]?.toString().includes(value),
    [iotv_v3_types_1.ExpressionFunctionType.NOT_CONTAINS]: (key, value) => (item) => !item[key]?.toString().includes(value),
    [iotv_v3_types_1.ExpressionFunctionType.EXISTS]: (key, value) => (item) => !!item[key],
    [iotv_v3_types_1.ExpressionFunctionType.NOT_EXISTS]: (key, value) => (item) => !item[key],
    [iotv_v3_types_1.ExpressionFunctionType.BEGINS_WITH]: (key, value) => (item) => item[key]?.toString().startsWith(value),
    [iotv_v3_types_1.ExpressionFunctionType.NOT_BEGINS_WITH]: (key, value) => (item) => !item[key]?.toString().startsWith(value),
    [iotv_v3_types_1.ComparisonType.LESS_THAN]: (key, value) => (item) => item[key] < value,
    [iotv_v3_types_1.ComparisonType.LESS_EQUAL]: (key, value) => (item) => item[key] <= value,
    [iotv_v3_types_1.ComparisonType.GREATER_THAN]: (key, value) => (item) => item[key] > value,
    [iotv_v3_types_1.ComparisonType.GREATER_EQUAL]: (key, value) => (item) => item[key] >= value,
};
const getFilterFnFromFilterPartType = (filterPartType) => {
    const { key, predicate, value } = filterPartType;
    const filterFn = (item) => {
        let pass = false;
        const filterFn = predicateToTestFn[filterPartType.predicate];
        /** To support dot notation (!) instead pass key accessed value from key splitting logic. As this changes predicateToTestFn, perhaps that logic goes there, or change all the function just to accept value from dot noted atts  */
        pass = filterFn(key, value)(item);
        return pass;
    };
    return filterFn;
};
// note this looks like it handles top level AND between nodeFilterGroups but not OR
/** returns array of filters each of which is has an array of subfilters which are AND or OR'd depending on the setOperation of the filterGroup */
const getFilterFnsFromFilterGroups = ({ filterGroups }) => {
    const filterFns = filterGroups.map((filterGroup) => {
        const subFilters = filterGroup.filters.map((filter) => getFilterFnFromFilterPartType(filter));
        debug && console.log('Subfilters', subFilters);
        let filterFn = (item) => true;
        // const setOperationFn = filterGroup.setOperation === LogicalOperatorType.AND ? subFilters.every : subFilters.some
        if (filterGroup.setOperation === iotv_v3_types_1.LogicalOperatorType.AND) {
            filterFn = (item) => subFilters.every((subFilter) => subFilter(item));
        }
        else {
            filterFn = (item) => subFilters.some((subFilter) => subFilter(item));
        }
        return filterFn;
    });
    return filterFns;
};
exports.getFilterFnsFromFilterGroups = getFilterFnsFromFilterGroups;
/** applies the array of filter functions derived from the nodeFilterGroup definitions */
const filterNodeList = ({ nodeFilterGroups, groupSetOperation = iotv_v3_types_1.LogicalOperatorType.AND, nodes }) => {
    debug && console.log('filtering', { nodes, nodeFilterGroups });
    const filterFns = (0, exports.getFilterFnsFromFilterGroups)({ filterGroups: nodeFilterGroups });
    //console.log(filterFns)
    let filterNodes = [];
    if (groupSetOperation === iotv_v3_types_1.LogicalOperatorType.AND) {
        // apply each filter the the filtered result of last filter (AND)
        filterNodes = filterFns.reduce((a, c) => a.filter(c), nodes);
    }
    else {
        const noFilters = filterFns.length === 0;
        filterNodes = nodes.reduce((a, c) => {
            // 2025 06 pass every node through every filter and if passes some add to result (OR), potentially
            if (noFilters || filterFns.some((fn) => fn(c))) {
                a.push(c);
            }
            return a;
        }, []);
    }
    return filterNodes;
};
exports.filterNodeList = filterNodeList;
/** Applies node filters to a group of nodes, then removes edges that only point to filtered out nodes
 * @returns Filtered nodes and only the edges that connect to them
 * */
const applyNodeFilter = ({ nodeFilterGroups, nodes, edges }) => {
    const filteredNodes = (0, exports.filterNodeList)({ nodeFilterGroups, nodes });
    const nodeFilteredEdges = [];
    /** only return edges which match filtered nodes, futher filtered from edge attribute filter, if it was run */
    edges.forEach((edge) => {
        const sourceOrTargetNodePresent = filteredNodes.find((node) => node.sk === edge.sk || node.pk === edge.pk);
        if (sourceOrTargetNodePresent) {
            nodeFilteredEdges.push(edge);
        }
    });
    return { filteredNodes, nodeFilteredEdges };
};
exports.applyNodeFilter = applyNodeFilter;
